/**
 * Which save a Flows-tab draft runs, per tracker. Voluum: the per-item PUT/POST
 * calls; Binom: the full-flow PUT — both exactly as before. Tres Commas: the
 * same per-item calls as Voluum (it is a Voluum-API clone), sent to its own
 * /tres-commas/flows routes, so a Tres Commas draft can never reach the Voluum
 * save (the ids look alike).
 * For Media Devoted | Created By Ciro Autiero
 */

import { matchTracker } from '@trafficpulse/shared';

import { dispatchTracker } from '@/hooks/campaign-tracker';
import type { CampaignProvider } from '@/hooks/voluum/useVoluum';

export interface FlowDraftSavers {
  voluum: () => Promise<void>;
  binom: () => Promise<void>;
  'tres-commas': () => Promise<void>;
}

export function saveFlowDraftFor(provider: CampaignProvider, savers: FlowDraftSavers): Promise<void> {
  return matchTracker(dispatchTracker(provider), {
    voluum: savers.voluum,
    binom: savers.binom,
    'tres-commas': savers['tres-commas'],
  });
}
